import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=3e5c3f00&scoped=true&lang=html&"
import script from "./judge.vue?vue&type=script&lang=js&"
export * from "./judge.vue?vue&type=script&lang=js&"
import style0 from "./judge.vue?vue&type=style&index=0&id=3e5c3f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5c3f00",
  null
  
)

export default component.exports